module.exports = __webpack_public_path__ + "img/iphone-6.c6fdd6b3.svg";